import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { CELLYTICS_DEFAULT_ANALYSIS_PATH, cellyticsSidebarRoutes } from '../cellytics-analysis';

const ACCESS_SESSION_KEY = "cellytics.access";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public homePath: string = CELLYTICS_DEFAULT_ANALYSIS_PATH;
    public collapsedDates: any = {};
    public analysisRouteConfig = cellyticsSidebarRoutes();

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isDateActive(route: any) {
        const currentPath = location.pathname;
        const prefixes = route.activePrefixes || [route.date];
        return currentPath === route.defaultPath || prefixes.some((prefix: string) => {
            return currentPath === `/${prefix}` || currentPath.indexOf(`/${prefix}/`) === 0;
        });
    }

    public isPageActive(page: any) {
        return location.pathname === page.path;
    }

    public isDateExpanded(route: any) {
        return route.pages.length > 0 && this.isDateActive(route) && this.collapsedDates[route.date] !== true;
    }

    public toggleDate(route: any, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (route.pages.length === 0) return;
        this.collapsedDates[route.date] = !this.collapsedDates[route.date];
    }

    public dateClass(route: any) {
        if (this.isDateActive(route)) {
            return "group flex w-full gap-x-2 items-center rounded-md bg-gray-100 px-2 py-1.5 text-[13px] font-semibold text-emerald-700";
        }
        return "group flex w-full gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-emerald-700";
    }

    public pageClass(page: any) {
        if (this.isPageActive(page)) {
            return "group flex gap-x-2 items-center rounded-md bg-emerald-50 px-2 py-1.5 text-[12px] font-semibold text-emerald-700";
        }
        return "group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[12px] font-medium text-gray-500 hover:bg-gray-50 hover:text-emerald-700";
    }

    public clearAccess() {
        window.sessionStorage.removeItem(ACCESS_SESSION_KEY);
    }
}

export default ComponentNavSidebarComponent;